import { AuthState, AuthResponseProps } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthLogin, AuthLogout, switchMerchant } from "./index";
import { removeAllState } from "helper/generalFunction";
import { ReduxStatus } from "../types";

export const initialState: AuthState = {
  data: {} as AuthResponseProps,
  status: "loading",
  error: {},
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAutoPickup (state, action: PayloadAction<{autoPickup: boolean}>) {
      state.data.data.merchant.autoPickup = action.payload.autoPickup;
    },
    updateMerchantData (state, action: PayloadAction<any>) {
      if (state.data && state.data.data && state.data.data.merchant) {
        state.data.data.merchant = {
          ...state.data.data.merchant,
          ...action.payload
        };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(AuthLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(AuthLogin.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status as ReduxStatus;
          state.error = action.payload.error;
        }
      })
      .addCase(AuthLogin.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error;
      })
      .addCase(AuthLogout.fulfilled, (state, action) => {
        removeAllState().then(() => {
          window.location.href = "/login";
        });
      })
      .addCase(switchMerchant.pending, (state) => {
        state.status = "loading";
      })
      .addCase(switchMerchant.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status as ReduxStatus;
          state.error = action.payload.error;
        }
      })
      .addCase(switchMerchant.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error;
      });
  },
});

export const AuthReducer = AuthSlice.reducer;

export const { setAutoPickup, updateMerchantData } = AuthSlice.actions;
